import type { ServiceHandler } from "../bridge/message-router";
import { usePluginStore } from "../state/plugin-store";

/**
 * 工具栏服务：接收插件对宿主工具栏按钮外观与显隐的增量更新，写入 `plugin-store` 中按插件 id 索引的按钮状态。
 */
export const toolbarServiceHandler: ServiceHandler = async (pluginId, method, params) => {
  const store = usePluginStore.getState();

  switch (method) {
    case "setVisible": {
      /* 控制该插件对应入口是否在工具栏上渲染 */
      const { visible } = params as { visible: boolean };
      store.updateToolbarButton(pluginId, { visible });
      return;
    }

    case "setTitle": {
      /* 更新按钮主文案（如插件名或动态状态摘要） */
      const { title } = params as { title: string };
      store.updateToolbarButton(pluginId, { title });
      return;
    }

    case "setBadge": {
      /* 角标：传 `null` 清除；否则展示短文本并可区分强调色（如未读/错误） */
      const { badge } = params as { badge: { text: string; variant?: "default" | "destructive" } | null };
      store.updateToolbarButton(pluginId, { badge });
      return;
    }

    case "setIcon": {
      /* 更新按钮图标资源标识（由宿主侧解析为具体图标组件或 URL） */
      const { icon } = params as { icon: string };
      store.updateToolbarButton(pluginId, { icon });
      return;
    }

    default:
      throw Object.assign(new Error(`Unknown toolbar method: ${method}`), { code: "UNKNOWN_METHOD" });
  }
};
